import { ChangeDetectionStrategy, Component, afterNextRender, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SwUpdateService } from './core/config/sw-update.service';

@Component({
  selector: 'app-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  private readonly swUpdate = inject(SwUpdateService);

  constructor() {
    afterNextRender(() => this.swUpdate.init());
  }
}
